import { createContext } from 'react';
import { ILocalization } from '../hooks/UseLocalization';

const I18nContext = createContext<ILocalization>({
    changeLanguage: () => {},
    translate: (key: string, params?: Record<string, string | number | boolean>) => key
});

export default I18nContext;